"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.StyledIcon = exports.StyledLink = exports.itemBaseStyle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const link_1 = __importDefault(require("../link"));
exports.itemBaseStyle = (0, styled_components_1.css) `
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 ${({ theme }) => theme.space.s200} 0 0;

    color: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.text.body)} !important;

    text-align: center;

    transition: all ease 50ms;

    & svg path {
      fill: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.text.body)};
    }

    &::after {
      content: '';

      position: absolute;
      bottom: -${({ theme }) => theme.space.s050};
      left: 50%;

      display: block;
      width: 0;
      height: 2px;
      margin: 0 ${({ theme }) => theme.space.s200} 0 0;

      background: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.main.base)};

      opacity: 0;
      transform: translateX(-50%);
    }

    &:hover {
      color: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.main.base)};

      & svg path {
        fill: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.main.base)};
      }

      &::after {
        width: 100%;

        opacity: 1;
        transition: all 150ms;
        transition-property: width, opacity;
      }
    }
  }
`;
exports.StyledLink = (0, styled_components_1.default)(link_1.default) `
  ${exports.itemBaseStyle}
`;
exports.StyledIcon = styled_components_1.default.span `
  ${exports.itemBaseStyle}
`;
exports.StyledLabel = styled_components_1.default.div `
  margin-top: 0;

  ${({ theme }) => (0, styled_components_1.css)(Object.assign(Object.assign({}, theme.typography.body.tinyTextMain), { fontWeight: theme.typography.body.regularTextMain.fontWeight }))};
`;
